export default __webpack_public_path__ + "static/media/agb.1e68c5e0.svg";